import store from '@/store';
import {
  VuexModule, Module, Mutation, Action, getModule,
} from 'vuex-module-decorators';

// eslint-disable-next-line import/named
import {
  // eslint-disable-next-line import/named
  getNotebookCompany,
  // eslint-disable-next-line import/named
  getNotebookJobs, getNotebookWorkers, setNotebookCompany, setNotebookJobs, setNotebookWorkers,
} from '@/plugins/cookies';
import { Applicant } from '@/api/Workers';

export interface INotebookState {
  notebookJobs: any
  notebookWorkers: Applicant[]
  notebookCompany: any
}

@Module({ dynamic: true, store, name: 'NotebookModule' })
class Notebook extends VuexModule implements INotebookState {
  notebookJobs = getNotebookJobs() ? JSON.parse(getNotebookJobs() as string) : [];

  notebookWorkers = getNotebookWorkers() ? JSON.parse(getNotebookWorkers() as string) : [];

  notebookCompany = getNotebookCompany() ? JSON.parse(getNotebookCompany() as string) : [];

  @Mutation
  SET_NOTEBOOK_JOB(payload: any) {
    this.notebookJobs.push(payload);
    setNotebookJobs(this.notebookJobs);
  }

  @Mutation
  DELETE_NOTEBOOK_JOB(payload: number) {
    this.notebookJobs.splice(
      this.notebookJobs.findIndex((v: { id: number }) => v.id === payload),
      1,
    );
    setNotebookJobs(this.notebookJobs);
  }

  @Mutation
  SET_NOTEBOOK_WORKER(payload: Applicant) {
    this.notebookWorkers.push(payload);
    setNotebookWorkers(this.notebookWorkers);
  }

  @Mutation
  DELETE_NOTEBOOK_WORKER(payload: Applicant['id']) {
    this.notebookWorkers.splice(
      this.notebookWorkers.findIndex((v: { id: number }) => v.id === payload),
      1,
    );
    setNotebookWorkers(this.notebookWorkers);
  }

  @Mutation
  SET_NOTEBOOK_COMPANY(payload: Applicant) {
    this.notebookCompany.push(payload);
    setNotebookCompany(this.notebookCompany);
  }

  @Mutation
  DELETE_NOTEBOOK_COMPANY(payload: Applicant['id']) {
    this.notebookCompany.splice(
      this.notebookCompany.findIndex((v: { id: number }) => v.id === payload),
      1,
    );
    setNotebookCompany(this.notebookCompany);
  }

  @Mutation
  DELETE_ALL_NOTEBOOK_NOTES() {
    this.notebookJobs = [];
    this.notebookWorkers = [];
    this.notebookCompany = [];
    setNotebookJobs(this.notebookJobs);
    setNotebookWorkers(this.notebookWorkers);
    setNotebookCompany(this.notebookCompany);
  }

  // Job
  @Action
  public SetNotebookJob(payload: any) {
    this.SET_NOTEBOOK_JOB(payload);
  }

  @Action
  public DeleteNotebookJob(payload: number) {
    this.DELETE_NOTEBOOK_JOB(payload);
  }

  // Company
  @Action
  public SetNotebookCompany(payload: any) {
    this.SET_NOTEBOOK_COMPANY(payload);
  }

  @Action
  public DeleteNotebookCompany(payload: number) {
    this.DELETE_NOTEBOOK_COMPANY(payload);
  }

  // All
  @Action
  public DeleteAllNotebookNotes() {
    this.DELETE_ALL_NOTEBOOK_NOTES();
  }
}

export const NotebookModule = getModule(Notebook);
